import { ReactElement } from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { getData, getChartOptions, dataExists } from './helper';
import GraphCard from '~/ui/components/reusable/GraphCard';
import { INotificationRule } from '~/services/api/notificationRules/types';
import { IReading } from '~/services/api/readings/types';
import { DeviceType } from '~/services/api/enums';

interface IProps {
  notificationRules: INotificationRule[];
  readings: IReading[];
  deviceTypeId: DeviceType;
}

const NotificationsSummary = ({
  notificationRules,
  readings,
  deviceTypeId,
}: IProps): ReactElement => {
  const title = 'Notifications Summary';

  const data = getData(readings, notificationRules, deviceTypeId);

  if (!dataExists(data)) {
    return <GraphCard title={title} showNoData />;
  }

  const options = getChartOptions(data, deviceTypeId);

  return (
    <GraphCard title={title}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </GraphCard>
  );
};

export default NotificationsSummary;
